import { motion } from "framer-motion";
import { Eyebrow } from "@/components/shared/Eyebrow";
import { Reveal } from "@/components/shared/Reveal";
import { CircuitBg } from "@/components/shared/CircuitBg";
import { DynIcon } from "@/components/shared/DynIcon";
import { useSolutions } from "@/hooks/useContent";

export function Automation() {
  const { data: solutions = [] } = useSolutions();

  return (
    <section data-testid="automation-section" className="relative bg-dark-2 text-white py-24 md:py-28 overflow-hidden">
      <CircuitBg className="absolute inset-0 w-full h-full" opacity={0.35} />
      <div className="absolute inset-0 bg-gradient-to-b from-dark-2 via-transparent to-dark-2" />

      <div className="relative mx-auto max-w-[1400px] px-5 md:px-8">
        <div className="max-w-2xl">
          <Eyebrow dark className="mb-6">OTOMASYON & TEKNOLOJİ</Eyebrow>
          <Reveal>
            <h2 className="font-head font-extrabold tracking-tight text-4xl md:text-5xl lg:text-6xl leading-[1.02]">
              Kontrolün olduğu yerde <span className="text-cyan text-glow">verimlilik</span> vardır.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-silver/70 text-lg leading-relaxed">
              PLC, HMI ve SCADA tabanlı kontrol mimarilerinden proses ve makine otomasyonuna kadar,
              üretiminizi izlenebilir, güvenilir ve verimli hale getiren otomasyon yetkinlikleri.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {solutions.slice(0, 8).map((sol, i) => (
            <motion.div
              key={sol.id || i}
              className="group bg-dark-2 p-6 md:p-8 hover:bg-navy transition-colors duration-400"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.06 }}
              data-testid={`automation-cap-${i}`}
            >
              <DynIcon name={sol.icon} className="w-8 h-8 text-cyan mb-5 transition-transform duration-300 group-hover:scale-110" />
              <h3 className="font-head font-semibold text-base md:text-lg text-white leading-snug">{sol.title}</h3>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
